module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl2-100.a39ef10b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/CommandCenter/images/command-center-lvl2-100.png
// module id = 3273
// module chunks = 11